import React from 'react';
import { Select } from '../Select/Select';
import './Filter.scss';
import { Icons } from '../Icons/Icons';
import clsx from 'clsx';

interface FilterOption {
  value: string;
  label: string;
}

interface SingleFilterConfig {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

interface FilterProps {
  hidden: boolean;
  options?: FilterOption[];
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  filters?: SingleFilterConfig | SingleFilterConfig[];
}

export const Filter: React.FC<FilterProps> = ({
  hidden = false,
  options,
  value,
  onChange,
  placeholder,
  filters,
}) => {
  const normalizedFilters = filters || {
    options: options || [],
    value: value || '',
    onChange: onChange || (() => {}),
    placeholder,
  };

  const filtersArray = Array.isArray(normalizedFilters) ? normalizedFilters : [normalizedFilters];
  const validFilters = filtersArray.filter((filter) => filter.options.length > 1);
  const isAnyFilterActive = filtersArray.some((filter) => Boolean(filter.value));

  const handleClearFilters = () => {
    filtersArray.forEach((filter) => filter.onChange(''));
  };

  if (validFilters.length === 0) {
    return null;
  }

  return (
    <div
      className={clsx('filter-group', {
        hidden: hidden,
        filtered: isAnyFilterActive,
      })}
    >
      {validFilters.map((filter, index) => (
        <div key={index} className="filter-item">
          {index === 0 && <span className="filter-group__label">Filter By</span>}
          <Select
            options={filter.options}
            value={filter.value}
            onChange={(newValue: unknown) => {
              if (typeof newValue === 'string') {
                filter.onChange(newValue);
              }
            }}
            placeholder={filter.placeholder}
          />
        </div>
      ))}
      <div className="clear-filter" onClick={handleClearFilters}>
        {Icons.Close}
        Reset Filters
      </div>
    </div>
  );
};
